<template>
    <v-app-bar dense app dark color="#006b69" height="80" class="poly-app-bar" elevation="0">
        <v-row align="center" justify="center" no-gutters style="height: 100%">
            <v-toolbar height="80" class="pa-0 ma-0" color="#006b69" elevation="0">
                <v-col class="headerTitleContainer pa-0" cols="4">
                    <v-toolbar-title class="headerTitle"><router-link to="/">Generatore di Soluzioni Impermeabili</router-link></v-toolbar-title>
                </v-col>

                <v-col class="text-left white--text d-flex" cols="7">
                    <v-container class="by-container pl-0 pt-5" >by</v-container>
                    <v-container class="px-0">
                        <img
                            height="40"
                            src="@/assets/polyglass-logo.png"
                            alt="Polylgass - Generatore di Soluzioni Impermeabili"
                        />
                    </v-container>

                </v-col>
                <v-col cols="1">
                    <v-menu v-if="showSelectLanguage" offset-y :close-on-click="closeOnClick">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark v-bind="attrs" v-on="on" small text outlined class="pr-1">
                                {{currentLocaleString}}
                                <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense tile>
                            <v-list-item-group >
                                <v-list-item v-for="(item, index) in langs" :key="index">
                                    <v-list-item-title @click="changeLanguage(item.id, item.desc)">{{ item.fulldesc }} </v-list-item-title>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-toolbar>
        </v-row>
    </v-app-bar>
</template>

<script>
import Api from "@/services/Api.js";

export default {
    created(){
        Api.langsList()
        .then((response) =>{
            this.langs = [...response.data.res]
            let currentLangObj = this.langs.filter(item => {
                return item.id == this.$store.state.locale
            })[0]
            this.$store.dispatch('updateCurrentLocaleString', currentLangObj.desc)
        })
    },

    computed:{
        showSelectLanguage(){
            return this.langs.length > 1 ? true : false
        },

        currentLocaleString(){
            return this.$store.state.currentLocaleString
        }
    },

    data(){
        return {
            langs: [],
            closeOnClick: true
        }
    },

    methods:{
        changeLanguage(langId, langString){
            this.$store.dispatch('updateLocale', langId)
            this.$i18n.locale = langId
            this.$store.dispatch('updateCurrentLocaleString', langString)
            this.$emit('change-language')
        }
    }
}
</script>

<style>
.poly-app-bar .v-toolbar__content{
    padding: 0 !important;
} 

.by-container{
    width: auto !important;
    font-style: italic;
}

.headerTitleContainer{
    background-color: #ffffff;
    border-bottom-right-radius: 40px;
    border-top-right-radius: 40px;
}
.headerTitleContainer .headerTitle a{
    height: 100%; 
    line-height: 80px !important;
    color: #006b69 !important;
    font-weight: 700;
    text-decoration: none;
}

.v-list-item:hover .v-list-item__title{
    color: #006b69 !important;
}

</style>


// WEBPACK FOOTER //
// src/components/Header.vue